export default "__VITE_ASSET__4ahuNiXH__"